import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetRoleListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    selectedCompanies: CustomMultiSelectModel[]
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetRoleListPagingAndFilterRequest: GetRoleListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    selectedCompanies: [],
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnFilters: []
}